import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" viewBox="0 0 24 24" className={ className } { ...props } fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M20 20V4H4V20H20ZM4 2H20C21.1 2 22 2.9 22 4V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2ZM11.0001 16.4142L17.7072 9.70711L16.293 8.29289L11.0001 13.5858L8.70718 11.2929L7.29297 12.7071L11.0001 16.4142Z" fill={ fill || 'currentColor' } />
    </svg>

);
